import moment from "moment";
import { useEffect, useState } from "react";
import Moment from "react-moment";
import useRazorpay from "react-razorpay";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Tooltip from "react-tooltip-lite";
import { API, baseURL, endpoints } from "../../api";
import { Confirmation, Error, Modal } from "../../components";
import { useAuth } from "../../context/Auth";
import { toastType } from "../../utils/strings";
import { errorToString } from "../../utils/utils";
import PaymentForm from "./payment-form";
import { ASYNC_STORAGE_KEYS, retrieveData } from "../../utils/storage";
import Content from "../../components/content";

const PayEvents = () => {
  const {
    showToast,
    showGlobalLoader: setLoading,
    globalLoader: loading,
  } = useAuth();
  const [events, setEvents] = useState([]);
  const [payingUsingStripe, setPayingUsingStripe] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const getData = () => {
    setLoading(true);
    API.get({ route: endpoints.EVENT_ENROL })
      .then((data) => {
        setEvents(data?.result);
      })
      .catch((data) => {
        showToast({
          text: errorToString(data?.response),
          type: toastType.ERROR,
        });
      })
      .finally(() => {
        setLoading(false);
        setLoaded(true);
      });
  };

  const withdrawEvent = (eventId) => {
    var data = new FormData();
    data.append("eventId", eventId);

    setLoading(true);
    API.post({ route: endpoints.WITHDRAW, data })
      .then(() => {
        getData();
      })
      .catch((data) => {
        showToast({
          text: errorToString(data?.response),
          type: toastType.ERROR,
        });
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getData();
  }, []);

  const location = useLocation()

  // /edit-events

  return <>
    <Content
      title={location?.pathname?.includes('edit') ? "Edit Event" : "Pay Event"}
      icon="fa-solid fa-money-check"
      loading={loading}
    >

      {
        location?.pathname?.includes('edit') ?
          null :
          <p className="mb-4 text-left"><span className="text-red">WARNING!</span> Once you pay your entry is complete and cannot be edited. Please consider this carefully if you are paying before entries close.</p>
      }
      {!loading && !events?.length && loaded ?
        <p className="font-xs">No Data to show</p> : null}

      {events?.length ?
        <table className="custom-table">
          <tr>
            <th style={{ minWidth: 250 }}>Events</th>
            <th className="hidden-sm" >Entries Close</th>
            <th className="hidden-sm">Owing</th>
            <th style={{ minWidth: 120 }}>Amount Paid</th>
            <th style={{ minWidth: 150 }}>Online Available</th>
            <th style={{ minWidth: 170 }}>In Person Available</th>
          </tr>
          {events?.map(({ id, events, actions }) => (
            <tr>
              <td>
                {events?.eventTitle}

                <div className="show-sm">
                  <br />
                  <strong>Entries Close: </strong> <Moment format="DD MMM YYYY">
                    {events?.entriesCloseTime}
                  </Moment>
                </div>
                <div className="show-sm">
                  <br />
                  <strong>Owing : </strong> {events?.eventCurrency?.sign}
                  {(parseFloat(actions?.amount) - parseFloat(actions?.paid ?? 0))?.toLocaleString("en-US")}
                </div>

                {/* <Row
                  events={events}
                  setPayingUsingStripe={setPayingUsingStripe}
                  actions={actions}
                /> */}

                <br />
                {moment().diff(events?.entriesEditableUntilTime, "days") <=
                  0 ? (
                  <Link to={`/edit-event/${id}`}>
                    <button class="form-control text-center small-btn text-white bg-gold-gradiant border-0 p-0 mr-1 ">
                      <i class="fa-solid fa-circle-plus"></i> Edit
                    </button>
                  </Link>
                ) : null}
                <div className="d-inline-block">
                  <Confirmation
                    btn={
                      <button class="form-control text-center small-btn text-black bg-gray-gradiant border-0 p-0 ">
                        Withdraw
                      </button>
                    }
                    title="Are you sure you want to withdraw from this event?"
                    yesText="Yes Withdraw"
                    noText="No"
                    yesClick={() => withdrawEvent(events?.id)}
                  />
                </div>
              </td>
              <td className="hidden-sm">
                <Moment format="DD MMM YYYY">
                  {events?.entriesCloseTime}
                </Moment>
              </td>
              <td className="hidden-sm">
                {events?.eventCurrency?.sign}
                {(parseFloat(actions?.amount) - parseFloat(actions?.paid ?? 0))?.toLocaleString("en-US")}
              </td>
              <td>{events?.eventCurrency?.sign}{actions?.paid ?? '0.00'}</td>
              <Row
                events={events}
                setPayingUsingStripe={setPayingUsingStripe}
                actions={actions}
              />
            </tr>
          ))}
        </table> : null
      }

    </Content>
    <Modal
      show={payingUsingStripe}
      onClick={() => {
        setPayingUsingStripe(false);
      }}
      close={() => {
        setPayingUsingStripe(false);
      }}
    >
      <div>
        <h2>Pay using Stripe</h2>
        <img className="stripe-image mt-3" src="./images/stripe.png" />
      </div>
      <div className="card-body d-flex align-items-center pt-0 ps-4 pe-4 pb-4 mt-4">
        <PaymentForm
          actionId={payingUsingStripe}
          setPayingUsingStripe={setPayingUsingStripe}
          eventName={
            payingUsingStripe &&
            events?.find(({ actionId }) => actionId === payingUsingStripe)
              ?.events?.eventTitle
          }
        />
      </div>
    </Modal>
  </>
};

export default PayEvents;

const Row = ({ events, setPayingUsingStripe, actions }) => {
  const hasInPersonPayment = events?.availablePayments?.find(
    ({ paymentType }) => paymentType === "in_person"
  );

  const hasInOnlinePayment = events?.availablePayments?.find(
    ({ paymentType }) =>
      paymentType === "stripe" ||
      paymentType === "rozar_pay" ||
      paymentType === "paypal"
  );

  const hasRazorPay = events?.availablePayments?.find(
    ({ paymentType }) => paymentType === "rozar_pay"
  );

  const hasStripe = events?.availablePayments?.find(
    ({ paymentType }) => paymentType === "stripe"
  );

  const hasPaypal = events?.availablePayments?.find(
    ({ paymentType }) => paymentType === "paypal"
  );

  const [Razorpay] = useRazorpay();
  const { user, showToast, showGlobalLoader: setLoading } = useAuth();
  const navigate = useNavigate();

  const handleRazorPayment = async () => {
    setLoading(true);
    API.get({
      route: `${endpoints.EVENT_PAY_RAZORPAY_ORDER}${actions?.id}`,
    })
      .then(async (data) => {
        console.log("then data => ", data);

        if (data?.status) {
          console.log("data => ", data?.result?.order_id);

          const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY, // Enter the Key ID generated from the Dashboard
            // amount: parseFloat(actions?.amount), // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            // currency: events?.eventCurrency?.currency,
            // name: "ICN",
            // description: "ICN",
            // image: "https://icn-member.web.app/images/icn-logo.png",
            order_id: data?.result?.order_id, //This is a sample Order ID. Pass the `id` obtained in the response of createOrder().
            handler: function (response) {
              setLoading(true);
              var data = new FormData();
              data.append("razorPaymentId", response.razorpay_payment_id);
              data.append("actionId", actions?.id);
              API.post({ route: endpoints.EVENT_PAY_RAZORPAY, data }).then(
                async (data) => {
                  console.log("data => ", data);
                  setLoading(false);

                  if (data?.status) {
                    try {
                      navigate(`/event-payment-success/${events?.eventTitle}`);
                    } catch (e) { }
                  } else {
                    showToast({ text: data?.message, type: toastType.ERROR });
                  }
                }
              );
            },
            prefill: {
              name: `${user?.user?.first_name} ${user?.user?.last_name}`,
              email: user?.user?.email,
              contact: user?.user?.mobile_number,
            },
            notes: {
              address: "ICN Event Payment",
            },
            theme: {
              color: "#3399cc",
            },
          };

          const rzp1 = new Razorpay(options);

          rzp1.on("payment.failed", function (response) {
            console.log("response => ", response);
            setLoading(false);
            showToast({
              text: response.error.reason + " - " + response.error.description,
              type: toastType.ERROR,
            });
          });

          rzp1.open();
        } else {
          showToast({ text: data?.message, type: toastType.ERROR });
          setLoading(false);
        }
      })
      .finally(() => {
        console.log("setLoading(false)");
        setLoading(false);
      });
  };

  const onPay = async () => {
    if (hasRazorPay) handleRazorPayment();
    else if (hasPaypal) {
      const token = (await retrieveData(ASYNC_STORAGE_KEYS.LOGIN_DATA, true))
        ?.access_token;
      window.location = `${baseURL}/api/v1/${endpoints.PAYPAL}${actions?.id}&token=${token}`;
    } else if (hasStripe) setPayingUsingStripe(actions?.id);
  };

  const payBtn = () => {
    var compareDate = moment(new Date()).format("YYYY-MM-DD");
    var startDate = moment(hasInOnlinePayment?.inPerStartDate).format("YYYY-MM-DD");
    var endDate = moment(hasInOnlinePayment?.inPerEndDate).format("YYYY-MM-DD");
    const date = moment(compareDate).isBetween(startDate, endDate, undefined, '()');

    if (moment(compareDate).isSame(endDate) || moment(compareDate).isSame(startDate) || date) {
      return <button
        onClick={onPay}
        class="form-control text-center small-btn text-white bg-cyan border-0 p-0 "
      >
        Pay Now
      </button>
    }
  }

  return (
    <>
      <td className="text-center">
        {hasInOnlinePayment ? (
          <>
            <span className="font-xsss">
              {moment(
                hasInOnlinePayment?.inPerStartDate
              ).format("DD MMM")} to {moment(
                hasInOnlinePayment?.inPerEndDate
              ).format("DD MMM")}
            </span>
            <br />
            <div>
              <Tooltip className="my-tooltip small-size" content="UPI Payment">
                {hasRazorPay ? (
                  <img
                    src="data:image/png;base64,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"
                    alt="upi"
                    style={{ maxWidth: 40 }}
                  />
                ) : null}{" "}
              </Tooltip>
              <Tooltip className="my-tooltip small-size" content="Credit Card">
                <i class="fa-solid fa-credit-card"></i>
              </Tooltip>{" "}
              <Tooltip
                className="my-tooltip small-size"
                content={`In Person payments can only be made from ${moment(
                  hasInOnlinePayment?.inPerStartDate
                ).format("DD MMM yyyy")} until ${moment(
                  hasInOnlinePayment?.inPerEndDate
                ).format("DD MMM yyyy")}`}
              >
                <i class="fa-solid fa-clock-rotate-left text-red"></i>
              </Tooltip>
            </div>

            {payBtn()}
          </>
        ) : <span className="text-red">Not Available</span>}
      </td>
      <td className="text-center">
        {hasInPersonPayment ? (
          <>
            <span className="font-xsss">
              {moment(
                hasInPersonPayment?.inPerStartDate
              ).format("DD MMM")} to {moment(
                hasInPersonPayment?.inPerEndDate
              ).format("DD MMM")}
            </span>
            <div>
              <Tooltip className="my-tooltip small-size" content="Cash">
                <i class="fa-solid fa-circle-dollar-to-slot"></i>
              </Tooltip>{" "}
              <Tooltip className="my-tooltip small-size" content="Credit Card">
                <i class="fa-solid fa-credit-card"></i>
              </Tooltip>{" "}
              <Tooltip
                className="my-tooltip small-size"
                content={`In Person payments can only be made from ${moment(
                  hasInPersonPayment?.inPerStartDate
                ).format("DD MMM yyyy")} until ${moment(
                  hasInPersonPayment?.inPerEndDate
                ).format("DD MMM yyyy")}`}
              >
                <i class="fa-solid fa-clock-rotate-left text-red"></i>
              </Tooltip>
              <br />
            </div>
          </>
        ) : null}
      </td>
    </>
  );
};
